import { ReplenishmentConstants } from "transfers/constants/ReplenishmentConstants";

export const BulkProductUploadConstants = {
  TEMPLATE_URL:
    "https://deliverr-shipping-plan-upload-templates.s3.us-east-1.amazonaws.com/BulkProductUploadTemplate.xlsx",
  INSTRUCTIONS_URL:
    "https://deliverr-shipping-plan-upload-templates.s3.us-east-1.amazonaws.com/BulkProductUploadInstructions.pdf",
  MAX_SKUS: ReplenishmentConstants.MAX_PRODUCT_LIMIT,
  MAX_FILE_SIZE: 2000 * 1024,
  SHEET_TO_PROCESS: "Data",
  HEADER_ROW: 1,
  SEPARATOR: ",",
  SUCCESS_STATUS: "SUCCESS",
  ERROR_STATUS: "ERROR",
} as const;
